import { ReportService } from '@/app/reports/share/report.service'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'


export default function reportForm() {

  const categoriesFilter = ref([])
  const ownersFilter = ref([])
  const typeFilter = ref(null)
  const groupFilter = ref(null)
  const contractsFilter = ref([])


  const devices = ref([])
  const geofences = ref([])
  const geofences_orig=ref([])
  const geofencesEnd=ref([]);
  const geofencesEnd_orig=ref([]);
  const categoriesOptionsByGeofence=ref([])
  const start_trip=ref('');


  const filter = ref({})

  watch([ categoriesFilter, ownersFilter,
    typeFilter, groupFilter, contractsFilter], () => {
    filter.value = {
      ...(ownersFilter.value && {owners: ownersFilter.value}),
      ...(typeFilter.value && {type: typeFilter.value}),
      ...(groupFilter.value && {group: groupFilter.value}),
      ...(categoriesFilter.value && {categories: categoriesFilter.value}),
      ...(contractsFilter.value && {contracts: contractsFilter.value}),
    }

    get_devices_list()
  })



  const get_devices_list = () => {
    ReportService.getDevicesOptions({
      type:'device',
      user: store.state.auth.userData.id,
      ...filter.value
    }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))
  }


  get_devices_list()


  /// filter getAreasOptions
  const filterStartTripAreas=(ariea)=>{
    ReportService.getAreasOptions({
      type:'geofence',
      category:ariea,
      user: store.state.auth.userData.id
    }).then(response => {
    
      if (response.data.length > 0) {
        geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name}))
        geofences.value.unshift({name: "all", id: "all"})
      }
    })

  }
  const filterEndTripAreas=(ariea)=>{
    ReportService.getAreasOptions({
      type:'geofence',
      category:ariea,
      user: store.state.auth.userData.id,
    }).then(response => {
      if (response.data.length > 0) {
        geofencesEnd.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name}))
        geofencesEnd.value.unshift({name: "all", id: "all"})

      }
    })

  }

  ReportService.getAreasOptions({
    type:'geofence',
    category:start_trip.value,
    user: store.state.auth.userData.id,
    cols:'owner_id,geofence_id,id,name,category'

  }).then(response => {
    geofences.value = response.data;
    geofencesEnd.value=response.data;
    geofences_orig.value=JSON.parse(JSON.stringify(response.data))
    
  })


  ReportService.getCategoriesOptionsBy({
    type:'geofence',

  }).then(response => categoriesOptionsByGeofence.value =convertArray(response.data))


   function convertArray(values){
    let   all=[];
    values.forEach(element => {
        all.push({"name":element,"id":element});

      });
      return all;
  };

  return {
    devices,
    geofences,
    geofencesEnd,
    geofences_orig,
    categoriesOptionsByGeofence,
    filterStartTripAreas,
    filterEndTripAreas,

    typeFilter,
    groupFilter,
    contractsFilter,
    ownersFilter,
    categoriesFilter,

    filter
  }
}
